'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var AlloyButton = require('../alloy-button/AlloyButton.js');
var HeaderFootnote = require('../alloy-table/HeaderFootnote.js');
var styles_module = require('./styles.module.scss.js');
var cx = require('classnames');
var ChevronUpIcon = require('../alloy-icon/ChevronUpIcon.js');
var ChevronDownIcon = require('../alloy-icon/ChevronDownIcon.js');
var SortByIcon = require('../alloy-icon/SortByIcon.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var SortButton = function (_a) {
    var _b;
    var active = _a.active, children = _a.children, buttonClassName = _a.buttonClassName, labelWrapperClassName = _a.labelWrapperClassName, invertArrows = _a.invertArrows, footnote = _a.footnote, _c = _a.disabled, disabled = _c === void 0 ? false : _c, onClick = _a.onClick, sortDirection = _a.sortDirection, hideSortButtons = _a.hideSortButtons;
    var getChevron = function (direction) {
        return direction === -1 ? (jsxRuntime.jsx(ChevronUpIcon.default, { className: cx__default.default('mt-1', styles_module.default['sort-chevron']) })) : (jsxRuntime.jsx(ChevronDownIcon.default, { className: cx__default.default('mt-1', styles_module.default['sort-chevron']) }));
    };
    var getIcon = function (active, direction) {
        return active ? (getChevron(direction)) : (jsxRuntime.jsx(SortByIcon.default, { className: cx__default.default(styles_module.default['sortby-chevron']) }));
    };
    return (jsxRuntime.jsxs(AlloyButton.AlloyButton, tslib.__assign({ className: cx__default.default(buttonClassName, (_b = {},
            _b[styles_module.default['sort-button']] = !invertArrows,
            _b)), buttonType: "table-header", onClick: onClick, disabled: disabled }, { children: [jsxRuntime.jsxs("span", tslib.__assign({ className: cx__default.default('d-flex', 'align-items-end', 'w-100', 'my-0', labelWrapperClassName, { 'flex-row-reverse': invertArrows }) }, { children: [jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default('flex-grow-1 text-start my-0', styles_module.default['btn__text-container']) }, { children: children })), jsxRuntime.jsx("span", tslib.__assign({ className: cx__default.default(styles_module.default['iconContainer'], 'my-0', {
                            'me-2': invertArrows,
                            'ms-2': !invertArrows
                        }) }, { children: !disabled && !hideSortButtons && getIcon(active, sortDirection) }))] })), jsxRuntime.jsx(HeaderFootnote.default, { footnote: footnote, invertArrowSpace: invertArrows })] })));
};
var SortButton$1 = SortButton;

exports.default = SortButton$1;
//# sourceMappingURL=SortButton.js.map
